import { SET_DEVICE_LOCATION } from "constants/actions";
import { createAction } from "redux-actions";

// Redux actions
export const setDeviceLocation = createAction(SET_DEVICE_LOCATION);
